import type { ReactNode } from "react";
import { FloatingLayerContext } from "./floatingLayerContext";
import type { ZFloatingHost } from "./zIndex";

/** Declares the stacking host for the tooltips and popovers rendered inside
 *  it. Any container that opens a new stacking level provides one, once,
 *  around its children — see zIndex.ts. */
export const FloatingLayerProvider = ({
  host,
  children,
}: {
  host: ZFloatingHost;
  children: ReactNode;
}) => (
  <FloatingLayerContext.Provider value={host}>
    {children}
  </FloatingLayerContext.Provider>
);
